import { ISession } from '@/store/types';
import Axios from 'axios';

const RESOURCE = '/api/sessions';

export default {
  /**
   * @param {String} sessionId is the _id of the session
   */
  get(sessionId: string) {
    return Axios.get(`${RESOURCE}/${sessionId}`);
  },

  /**
   * @param {String} sessionUrl is the s3 object link
   */
  getSignedSession(sessionUrl: string) {
    return Axios.get(`${RESOURCE}/secure?url=${sessionUrl}`);
  },

  list() {
    return Axios.get(`${RESOURCE}`);
  },

  /**
   * @param {Object} session properties to create the session
   * @param {String} session.orgId _id of the org to link
   * @param {String} session.customer stripe customer id
   */
  create(session: ISession) {
    return Axios.post(`${RESOURCE}/`, session);
  },

  /**
   * @param {String} sessionId is the _id of the session
   * @param {Object} session contains properties to update
   * @param {String} session.cancelReason ENUM reason user canceled
   * @param {String} session.cancelFeedback free text of why they cancel
   * @param {String} session.offerId _id of what was offered
   * @param {Boolean} session.success whether they accepted the offer
   */
  update(sessionId: string, session: any) {
    return Axios.get(`${RESOURCE}/${sessionId}`, session);
  },

  /**
   * @param {String} sessionId is the _id of the session
   */
  delete(sessionId: string) {
    return Axios.get(`${RESOURCE}/${sessionId}`);
  },
};
